document.addEventListener('DOMContentLoaded', () => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  
  var terms = params.q.split(' OR ')

  for (let index = 0; index < terms.length; index++) {
    const element = terms[index];
    var elementQuery = "[" + element + "]"
    var filterTags = document.querySelectorAll(elementQuery)
    for (let i = 0; i < filterTags.length; i++) {
      const element2 = filterTags[i];
      element2.classList.add('active')
    }
  }
    
 
})